export default "__VITE_ASSET__e9143c84__"